// das Overlay wird durch das navMain-Modul sichtbar/unsichtbar gemacht
S.bglayer =
    {
        config: {},

        elements: {
        },

        init()
        {
            this.closeMobileNav();
        },

        closeMobileNav()
        {
            this.$module.on('click', () =>
            {
                if ($('.mod-header').length > 0)
                {
                    // bei mobile offen
                    if ($('.mod-header').hasClass('is-mobile-nav-open'))
                    {
                        S.header.closeMobileNav();

                        // S.slide.close();
                    }

                    S.header.searchLayerClose();
                }
                this.close();
            });
        },

        open()
        {
            if (this.$module)
            {
                this.$module.stop().fadeIn();
                this.$module.addClass('is-active');
            }
        },

        close()
        {
            if (this.$module)
            {
                this.$module.stop().fadeOut();
                this.$module.removeClass('is-active');
            }
        },

        toggle()
        {
            if (this.$module)
            {
                this.$module.stop().fadeToggle();
                this.$module.toggleClass('is-active');
            }
        },
    };
